var vehicleFinderInit = function () {
    $('[data-id="vehicle-finder-search-submit"]').each(function () {
        new VehicleFinder($(this)).init();
    });
};

(function ($) {

    'use strict';
    
    var VehicleFinder = window.VehicleFinder = function (submitButton) {
        var self = this;
        var modelOptions = "[data-id='model-options']";
        var makeOptions = "[data-id='make-options']";
        var submitButton = "[data-id='vehicle-finder-search-submit']";

        var addEvents = function () {

            $(submitButton).on('click', function (evt) {

                var isValid = $(this).parents("form").data('validator').element("[data-id=vehicle-finder-search-field]");

                if(!isValid)
                {
                    evt.preventDefault();
                }

            });

            $(makeOptions).on('change', function () {
                $(modelOptions).empty();

                var make = $(makeOptions).val();

                $.post('/gis/findvehiclemodels?makeWithCode=' + make)
                    .done(function (data) {
                        showModelResults(data);
                    })
                    .fail(function (data) {
                        showModelResults(data);
                    });
            });
        };

        var showModelResults = function (modelData) {

            if (modelData) {
                $(modelOptions).append(modelData);
            };
        };

        var showField = function (field) {
            field.removeClass("x");
            field.show();
        };

        var hideField = function (field) {
            field.addClass("x");
            field.hide();
        };

        self.init = function () {
            if (submitButton[0]) {
                addEvents();
            }
        };
    };
})(jQuery);